export let projectStateTag = {
  bindings: {
    project: '<'
  },
  template: `
    <div class="text-xxs projectTypeTag font-bold text-block" ng-class="proStateVM.tagClass(proStateVM.project)">
      <p class="text-block no-margin">{{ proStateVM.project.estatus }}</p>
    </div>`,
  controllerAs: 'proStateVM',
  controller: ['Validations', 'Ramda',
  function (Validations, Ramda) {
    const R = Ramda

    const tagClass = R.curry((lib, project) => {
      
      if (lib.inReview(project.projectStateId)) {
          return 'azul'
      } else if (lib.inApproval(project.projectStateId)) {
          return 'azul'
      } else if (lib.inExecution(project.projectStateId)) {
          return 'verde'
      } else if (lib.inReviewExecution(project.projectStateId)) {
          return 'morado'
      } else if (lib.inEvaluation(project.projectStateId)) {
          return 'morado'
      } else {
          return 'verde'
      }
    })

    this.tagClass = tagClass(Validations)
  }
]}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/extensionProjects/list/projects/project-state-tag.js